import { alpha } from '@mui/material/styles';
import { ICustomTheme } from '../types/ICustomTheme';

export const DarkPalette: ICustomTheme['palette'] = {
     mode: 'dark',
     primary: {
          main: '#3b82f6', // Blue moderno mais vibrante
          light: alpha('#3b82f6', 0.8),
          dark: '#1e40af',
          contrastText: '#FFFFFF',
     },
     secondary: {
          main: '#06b6d4', // Cyan moderno mais equilibrado
          light: alpha('#06b6d4', 0.8),
          dark: '#0891b2',
          contrastText: '#FFFFFF',
     },
     tertiary: {
          main: '#f59e0b', // Amber mais suave que amarelo puro
          light: alpha('#f59e0b', 0.8),
          dark: '#d97706',
          contrastText: '#000000',
     },
     alternate: {
          main: '#374151', // Gray-700 mais moderno
          light: alpha('#374151', 0.8),
          dark: '#1f2937',
          contrastText: '#FFFFFF',
     },
     text: {
          primary: '#f8fafc', // Branco mais suave para os olhos
          secondary: '#94a3b8', // Gray-400 mais legível
     },
     background: {
          paper: '#282a36', // Fundo principal para cards/dialogs
          default: '#21222c', // Fundo geral da aplicação
          // Para casos de fundo "mais escuro" (ex: sidebar, overlays):
          deep: '#191a21',
     },
     accent1: {
          main: 'rgba(59, 130, 246, 0.15)', // Primary com transparência
          light: 'rgba(59, 130, 246, 0.10)',
          dark: 'rgba(59, 130, 246, 0.25)',
          contrastText: '#FFFFFF',
     },
     accent2: {
          main: 'rgba(6, 182, 212, 0.15)', // Secondary com transparência
          light: 'rgba(6, 182, 212, 0.10)',
          dark: 'rgba(6, 182, 212, 0.25)',
          contrastText: '#FFFFFF',
     },
     accent3: {
          main: 'rgba(245, 158, 11, 0.15)', // Tertiary com transparência
          light: 'rgba(245, 158, 11, 0.10)',
          dark: 'rgba(245, 158, 11, 0.25)',
          contrastText: '#000000',
     },
     accent4: {
          main: 'rgba(55, 65, 81, 0.60)', // Alternate com transparência
          light: 'rgba(55, 65, 81, 0.40)',
          dark: 'rgba(55, 65, 81, 0.80)',
          contrastText: '#FFFFFF',
     },     // Cores modernas aprimoradas
     info: {
          main: '#0ea5e9', // Sky-500 - mais vibrante
          light: alpha('#0ea5e9', 0.8),
          dark: '#0284c7',
          contrastText: '#FFFFFF',
     },
     neutral: {
          main: '#64748b', // Slate-500 - mais equilibrado
          light: alpha('#64748b', 0.8),
          dark: '#475569',
          contrastText: '#FFFFFF',
     },
     pastel1: {
          main: '#8db4d8', // Blue pastel mais suave
          light: alpha('#8db4d8', 0.8),
          dark: '#7c9cc7',
          contrastText: '#000000',
     },
     pastel2: {
          main: '#a78bfa', // Violet pastel moderno
          light: alpha('#a78bfa', 0.8),
          dark: '#9333ea',
          contrastText: '#000000',
     },
     pastel3: {
          main: '#fb7185', // Rose pastel equilibrado
          light: alpha('#fb7185', 0.8),
          dark: '#e11d48',
          contrastText: '#FFFFFF',
     },
     vibrant1: {
          main: '#ef4444', // Red moderno mais equilibrado
          light: alpha('#ef4444', 0.8),
          dark: '#dc2626',
          contrastText: '#FFFFFF',
     },
     vibrant2: {
          main: '#10b981', // Emerald vibrante
          light: alpha('#10b981', 0.8),
          dark: '#059669',
          contrastText: '#FFFFFF',
     },
     vibrant3: {
          main: '#f97316', // Orange vibrante moderno
          light: alpha('#f97316', 0.8),
          dark: '#ea580c',
          contrastText: '#FFFFFF',
     },
     error: {
          main: '#ef4444', // Red-500 mais moderno
     },
     warning: {
          main: '#f59e0b', // Amber-500 mais equilibrado
     },
     success: {
          main: '#10b981', // Emerald-500 mais vibrante
     },
     divider: '#334155', // Slate-700 - divisor mais sutil
};
